import i18next from "i18next";
import { initLitI18n, translate } from "lit-i18n";
import { logger } from "../util/Logger";
import { en } from "./en";
import { tr } from "./tr";
import { de } from "./de";

/** Locales shipped in room-designer / configurator resource packs. */
export const plannerLocales = ["en", "tr", "de"] as const;
export type PlannerLocale = (typeof plannerLocales)[number];

/** Map host/app locale → planner locale; unsupported codes fall back to `en`. */
export function resolvePlannerLocale(
  lang: string | null | undefined,
): PlannerLocale {
  const code = (lang ?? "").trim().toLowerCase().split("-")[0] ?? "";
  if (code === "en" || code === "tr" || code === "de") return code;
  return "en";
}

export function setPlannerLanguage(lang: string | null | undefined): void {
  void i18next.changeLanguage(resolvePlannerLocale(lang));
}

i18next.use(initLitI18n).init({
  resources: {
    en: {
      translation: en,
    },
    tr: {
      translation: tr,
    },
    de: {
      translation: de,
    },
  },
  lng: navigator.language,
  fallbackLng: "en",
});

logger.debug("navigator.language", navigator.language);

export { translate as t };
